export const mapRegularLetterAppearance = (letter: string): string => {
  const lowerCaseLetter = letter.toLowerCase();
  const isUpperCase = letter !== lowerCaseLetter;
  const transformLetter = isUpperCase ? (l: string): string => l.toUpperCase() : (l: string): string => l;
  switch (lowerCaseLetter) {
    case 'ā':
    case 'á':
    case 'à':
    case 'â':
    case 'ä':
    case 'å':
      return transformLetter('a');
    case 'ç':
      return transformLetter('c');
    case 'ē':
    case 'é':
    case 'è':
    case 'ê':
    case 'ë':
      return transformLetter('e');
    case 'ī':
    case 'í':
    case 'ì':
    case 'î':
    case 'ï':
    case 'ɪ':
      return transformLetter('i');
    case 'ñ':
      return transformLetter('n');
    case 'ō':
    case 'ó':
    case 'ò':
    case 'ô':
    case 'ö':
      return transformLetter('o');
    case 'ū':
    case 'ú':
    case 'ù':
    case 'û':
    case 'ü':
      return transformLetter('u');
    case 'ÿ':
    case 'ӯ':
      return transformLetter('y');
    default:
      return letter;
  }
};
